"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageAmplifyEffectHandler = exports.DamageAmplifyEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DamageAmplifyEffectArgs {
    constructor(damageAmplificationPercentOverride) {
        this.damageAmplificationPercentOverride = damageAmplificationPercentOverride;
        this.__type = EffectType_1.EffectType.DamageAmplify;
        this.__typeName = "DamageAmplify";
        this.name = "Damage Amplify";
        this.harmful = false;
    }
}
exports.DamageAmplifyEffectArgs = DamageAmplifyEffectArgs;
let DamageAmplifyEffectHandler = class DamageAmplifyEffectHandler {
    apply(sequence, container, state) {
        state.meta.damageIncreaseEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamagePercentIncrease, state.args.damageAmplificationPercentOverride),
            duration: Duration_1.Duration.Instant
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.damageIncreaseEffectId);
    }
};
DamageAmplifyEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DamageAmplify)
], DamageAmplifyEffectHandler);
exports.DamageAmplifyEffectHandler = DamageAmplifyEffectHandler;
